/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
var MovingState;
(function (MovingState) {
  MovingState["NONE"] = "none";
  MovingState["DOWN"] = "down";
  MovingState["UP"] = "up";
  MovingState["UNKNOWN"] = "unknown";
})(MovingState || (MovingState = {}));
var LoadState;
(function (LoadState) {
  LoadState["NORMAL"] = "normal";
  LoadState["FULL"] = "full";
  LoadState["OVERLOAD"] = "overload";
  LoadState["UNKNOWN"] = "unknown";
})(LoadState || (LoadState = {}));
var CallStatus;
(function (CallStatus) {
  CallStatus["CREATED"] = "created";
  CallStatus["APPROVED"] = "approved";
  CallStatus["SERVED"] = "served";
  CallStatus["CANCELLED"] = "cancelled";
  CallStatus["TIMEOUT"] = "timeout";
})(CallStatus || (CallStatus = {}));

export { CallStatus as C, MovingState as M };

//# sourceMappingURL=kone-elevators-interface-6c591b7f.js.map